import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AskComment } from 'src/app/interfaces/ask';
import { AskScreenName } from 'src/app/services/log/ask/ask-log';

@Component({
  selector: 'app-ask-comment',
  templateUrl: './ask-comment.component.html',
  styleUrls: ['./ask-comment.component.scss'],
})
export class AskCommentComponent implements OnInit {

  constructor() { }

  @Input() postId: number | undefined;
  @Input() data: AskComment | undefined;
  @Input() entryPointPostId: number | undefined;
  @Input() location: AskScreenName = 'ask_post_detail';
  @Output() onClickLike = new EventEmitter<boolean>();

  ngOnInit() {}

}
